import { useMemo, useState } from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import moment from 'moment'

import { Flex, FlexContainer } from 'components/Flex'
import ListAction from 'components/ListAction'
import ListFilter from 'components/ListFilter'
import ListSort from 'components/ListSort'
import Panel from 'components/Panel'
import { useDoc } from 'lib/firestore'
import { categories } from 'utils/constant'

import ListItem from './DashboardListItem'

export default function StockList() {
  const [selected, setSelected] = useState(null)
  const [sort, setSort] = useState({ field: 'price', order: 'desc' })
  const [filter, setFilter] = useState({ expire: 3, category: '*' })
  const { item } = useDoc(`shared/count/expire/${filter.expire}`)

  const accounts = useMemo(() => {
    if (!item) return []
    return item.data
      .find(x => filter.category === x.category)
      .accounts.sort((a, b) => {
        const order = sort.order === 'asc' ? 1 : -1
        return a[sort.field] < b[sort.field] ? -order : order
      })
  }, [item, filter, sort])

  const handleClick = account => {
    if (selected && selected.id === account.id) {
      setSelected(null)
    } else {
      setSelected(account)
    }
  }

  const handleChangeFilter = (field, value) => {
    setFilter(current => ({ ...current, [field]: value }))
  }

  const handleChangeSort = field => {
    setSort(current => ({
      field,
      order: current.field !== field || current.order === 'desc' ? 'asc' : 'desc',
    }))
  }

  if (!item) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <Flex>
      <ListAction>
        <ListFilter
          fields={[
            {
              id: 'expire',
              name: '期限',
              options: [
                { value: 0, label: '期限切れ' },
                { value: 3, label: '3 ヶ月以内' },
                { value: 6, label: '6 ヶ月以内' },
                { value: 12, label: '1 年以内' },
                { value: 18, label: '1 年半以内' },
              ],
              excludeAllOption: true,
            },
            { id: 'category', name: 'カテゴリ', options: categories },
          ]}
          value={filter}
          onChange={handleChangeFilter}
        />
      </ListAction>
      <Panel>
        <ListSort
          title={`最終更新日時: ${moment(item.updatedAt).format('MM/DD HH:mm')}`}
          fields={[
            { id: 'amount', name: '在庫数' },
            { id: 'price', name: '金額' },
          ]}
          value={sort}
          onChange={handleChangeSort}
        />
        {accounts.map(x => (
          <ListItem
            key={x.id}
            data={x}
            open={selected && selected.id === x.id}
            onClick={() => handleClick(x)}
          />
        ))}
      </Panel>
    </Flex>
  )
}
